export const Loading = {
  namespaced: true,
  state: {
    isActive: false,
    lastView: null
  },
  getters: {
    // ローディングのステート取得
    isLoading: (state) => state.isActive,
    lastView: state => state.lastView
  },
  mutations: {
    UPDATE_IS_ACTIVE (state, payload) {
      state.isActive = payload
    },
    SET_LAST_VIEW (state, item) {
      state.lastView = item
    }
  },
  actions: {
    /**
     * Loadingの表示アクション
     */
    actionToggleLoading ({ commit }, isActive) {
      commit('UPDATE_IS_ACTIVE', isActive)
    },
    setLastView: ({ commit }, payload) => {
      commit('SET_LAST_VIEW', payload.lastView)
    }
  }
}
